/* eslint-disable max-len */
import React, { useState } from 'react';
import moment from 'moment';
import edit from '../Res/Icon/edit.png';
import { useDispatch, useSelector } from 'react-redux';
import CustomModal from './CustomModal';
import RequestEdit from './RequestEdit';
import { updateUserRequest } from '../actions/Users';
import Spinner from './Spinner/Spinner';
import { toast } from 'react-toastify';
import ConfirmationModal from './ConfirmationModal';
import { addSystemLogs } from '../actions/SystemLogs';
import RequestReject from './RequestReject';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes} from '@fortawesome/free-solid-svg-icons';

const RequestsData = ({
  item,
}) => {
  const {
    email,
    name,
    companyName,
    company,
    status,
    is3rdPartyAgent,
    createdAt
  } = item;

  const requestDate = moment.utc(createdAt).format('MM/DD/YYYY hh:mm A')

  const dispatch = useDispatch();
  const token = localStorage.getItem('jwtToken') || null;
  const userApp = useSelector(state => state.AppState.user);

  const [selectedRequest, setSelectedRequest] = useState(null)
  const [editModalStatus, setEditModalStatus] = useState(false);
  const [updateUser, setUpdateUser] = useState({});
  const [loading, setLoading] = useState(false);
  const [warningModal, setWarningModal] = useState(false);
  const [confirmationBodyText, setConfirmationBodyText] = useState('');
  const [rejectModalStatus, setRejectModalStatus] = useState(false);
  const [rejectReasonMessage, setRejectReasonMessage] = useState('');

  const onEditBtn = selectedItem => {
    setSelectedRequest(selectedItem);
    setEditModalStatus(true)
  }

  const onChangeSubmit = async () => {
    if (updateUser.status !== 'Rejected' && !updateUser?.role) {
      toast.error('Please select role');
      return;
    } else if (updateUser?.status === "Pending") {
      toast.error('Please change the status');
      return;
    } else if (updateUser?.status === "Approved") {
      setConfirmationBodyText(`You are about to create a User account for ${name} assigned to ${updateUser?.selectedCompanyName}. Are you sure you want to proceed?`);
      setWarningModal(true);
    } else if (updateUser?.status === "Rejected") {
      setRejectModalStatus(true);
    }
  }

  const confirmationSubmit = async () => {
    setLoading(true);
    const updateUserData = updateUser.status === "Rejected" ? { ...updateUser, reason: rejectReasonMessage } : updateUser;
    const requestsData = await dispatch(updateUserRequest(token, updateUserData));
    if (requestsData?.success) {
      if (updateUser?.status === "Approved") {
        const body = {
          actionType: 'system',
          description: `User: ${name} account request has been ${updateUser?.status}`,
        };
        await dispatch(addSystemLogs(token, body));
      }
      setWarningModal(false)
      setEditModalStatus(false);
    }
    setLoading(false);
  }

  const updatedUserData = updatedUser => {
    setUpdateUser(updatedUser);
  }

  const rejectionReason = reason => {
    setRejectReasonMessage(reason.reason);
  }

  const onRejectSubmit = async () => {
    if (rejectReasonMessage) {
      await confirmationSubmit();
      const body = {
        actionType: 'system',
        description: `Rejected Account Request for username: ${name} and email: ${email} with reason: ${rejectReasonMessage}.`,
      };
      await dispatch(addSystemLogs(token, body));
      setRejectModalStatus(false);
    } else {
      toast.error('Please specify reason');
    }
  }

  return (
    <>
      {
        loading && (
          <Spinner />
        )
      }
      <tr>
        <td>{name}</td>
        <td>{email}</td>
        <td>{companyName}</td>
        <td>{company?.epikCustomerId || '-'}</td>
        <td>{requestDate}</td>
        <td>
          {status}
        </td>
        <td>
          {is3rdPartyAgent ? (
            <FontAwesomeIcon icon={faCheck} />
          ) : (
            <FontAwesomeIcon icon={faTimes} />
          )}
        </td>
        {(userApp.role === 'admin' ||
          userApp.role === 'enterpriseAdmin' ||
          userApp.role === 'superAdmin' ||
          userApp.role === 'companyGroupAdmin' ||
          userApp.role === 'companyGroupManager') && (
            <td style={{ minWidth: '100px' }}>
              <img
                onClick={() => onEditBtn(item)}
                className="actions-icon"
                src={edit}
                alt="edit"
              />
            </td>
          )}
      </tr>

      <CustomModal
        header={`Edit Request: ${selectedRequest?.email}`}
        isOpen={editModalStatus}
        onConfirm={onChangeSubmit}
        onCancel={() => setEditModalStatus(false)}
        customButtomColor="primary">
        <RequestEdit updatedUserData={updatedUserData} selectedRequest={selectedRequest} />
      </CustomModal>

      <CustomModal
        header={`Reason For Rejection`}
        isOpen={rejectModalStatus}
        onConfirm={onRejectSubmit}
        onCancel={() => setRejectModalStatus(false)}
        customButtomColor="primary">
        <RequestReject rejectionReason={rejectionReason} />
      </CustomModal>

      <ConfirmationModal
        isOpen={warningModal}
        onCancel={() => setWarningModal(false)}
        onConfirm={confirmationSubmit}
        bodyText={confirmationBodyText}
        confirmBtnText="Continue"
        headerText="Confirm User Account Creation"
      />
    </>
  );
};

export default RequestsData
